import React from 'react';
import BuscadorArticulos from '../containers/BuscadorArticulos';
import { sendMessageGW1 } from '../../../helpers/GW1sendMessage.helper';
import {sendCloseMessageGW1} from "../../../helpers/GW1sendMessage.helper";
import { obtenerFiltrosFromGw1 } from '../../../state/actions/creators/articulos.actioncreator';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ARTICULOS_FILTROS_REQUEST } from '../../../state/actions/constants/articulos.constants';

class ArticulosBuscadorPage extends React.Component {

  componentDidMount() {
    const { filtros } = this.props;
    if (filtros === undefined) {
      const { obtenerFiltrosFromGw1 } = this.props;
      if (filtros) {
        obtenerFiltrosFromGw1();
      }
    }
  }
  
  render() {
    const { filtros } = this.props;
    return (
      <BuscadorArticulos

        numeroDeArticulos={12}

        gluedFilter={filtros}

        endpoint={ARTICULOS_FILTROS_REQUEST}

        ordenable={[
          { label: 'Ordenar por nombre', value: 'nombre' },
          { label: 'Ordenar por precio', value: 'precio_1' },
        ]}

        preload={false}

        onSeleccion={(seleccion) => {
          sendMessageGW1({ action: 'ARTICULOS_SELECCIONAR_PARA_ENCARGO', payload: seleccion });
        }}

        styles={{
          contenedorListado: { height: '400px', overflowY: 'scroll' },
          contenedorListadoPaginacion: { minHeight: '470px' },
        }}
        modosVisualizacion={["grid","lista"]}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { articulos: { filtros } } = state;

  if (filtros === null || filtros === undefined) {
    return {};
  }
  return {
    filtros,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    obtenerFiltrosFromGw1,
  }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArticulosBuscadorPage);
